$(document).ready(function() {
    $('.diamond-section-slider .senat-catalog-section-list-gallery').slick({
        infinite: false,
        slide: '.senat-cat-item.NEW',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});